import type { ComponentPropsWithoutRef } from 'react'

export const Label = ({
  labelText,
  htmlFor,
  required,
  ...rest
}: ComponentPropsWithoutRef<'label'> & {
  labelText: string
  htmlFor: string
  required?: boolean
}) => {
  return (
    <label
      htmlFor={htmlFor}
      {...rest}
      className="flex items-center gap-1 text-left text-base leading-body text-ink"
    >
      {labelText}
      {required && (
        <>
          <span aria-hidden className="text-xxs text-ink-danger">
            ※
          </span>
          <span className="sr-only">（必須）</span>
        </>
      )}
    </label>
  )
}
